/**
 * Careers Page Functionality
 * - Location filtering
 * - Multi-step application form
 */

(function() {
  'use strict';

  // Location Filtering
  const initLocationFilter = () => {
    const filterButtons = document.querySelectorAll('[data-filter]');
    const careerTiles = document.querySelectorAll('.m-career-tile');

    if (filterButtons.length === 0 || careerTiles.length === 0) return;

    filterButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const filter = btn.dataset.filter;

        // Update active button
        filterButtons.forEach(b => b.classList.remove('m-careers-filter-btn--active'));
        btn.classList.add('m-careers-filter-btn--active');

        // Filter tiles
        careerTiles.forEach(tile => {
          if (filter === 'all' || tile.dataset.location === filter) {
            tile.style.display = 'block';
            // Trigger animation if needed
            setTimeout(() => {
              tile.style.opacity = '1';
              tile.style.transform = 'translateY(0)';
            }, 10);
          } else {
            tile.style.opacity = '0';
            tile.style.transform = 'translateY(-10px)';
            setTimeout(() => {
              tile.style.display = 'none';
            }, 300);
          }
        });
      });
    });
  };

  // Multi-Step Form
  const initMultiStepForm = () => {
    const form = document.getElementById('careerForm');
    if (!form) return;

    const steps = form.querySelectorAll('.m-career-form__step');
    const nextButtons = form.querySelectorAll('.m-career-form__next');
    const prevButtons = form.querySelectorAll('.m-career-form__prev');
    let currentStep = 0;

    // Show first step
    if (steps.length > 0) {
      steps[0].classList.add('m-career-form__step--active');
    }

    // Next button handler
    nextButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const currentStepEl = steps[currentStep];
        const inputs = currentStepEl.querySelectorAll('input[required], textarea[required]');
        let isValid = true;

        // Validate current step
        inputs.forEach(input => {
          if (!input.value.trim()) {
            isValid = false;
            input.classList.add('form-field--error');
          } else {
            input.classList.remove('form-field--error');
          }
        });

        if (!isValid) {
          return;
        }

        // Hide current step
        currentStepEl.classList.remove('m-career-form__step--active');
        currentStep++;

        // Show next step
        if (steps[currentStep]) {
          steps[currentStep].classList.add('m-career-form__step--active');
          // Scroll to top of form
          form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    // Previous button handler
    prevButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const currentStepEl = steps[currentStep];
        currentStepEl.classList.remove('m-career-form__step--active');
        currentStep--;

        if (steps[currentStep]) {
          steps[currentStep].classList.add('m-career-form__step--active');
          form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    // File input validation
    const fileInput = form.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.addEventListener('change', (e) => {
        const file = e.target.files[0];
        if (file) {
          const maxSize = 10 * 1024 * 1024; // 10MB
          if (file.size > maxSize) {
            alert('File size must be less than 10MB');
            e.target.value = '';
          }
        }
      });
    }
  };

  // Render Rich Text JSON from Metaobjects
  const renderRichTextJSON = () => {
    const richTextContainers = document.querySelectorAll('[data-rich-text-json]');
    
    richTextContainers.forEach(container => {
      const jsonStr = container.getAttribute('data-rich-text-json');
      if (!jsonStr || jsonStr.includes('<')) return; // Skip if already HTML
      
      try {
        const json = JSON.parse(jsonStr);
        const html = parseRichTextJSON(json);
        if (html) {
          container.innerHTML = html;
        }
      } catch (e) {
        console.error('Error parsing rich text JSON:', e);
      }
    });
  };

  // Parse Shopify rich text JSON structure to HTML
  const parseRichTextJSON = (node) => {
    if (!node || !node.type) return '';
    
    let html = '';
    
    switch (node.type) {
      case 'root':
        if (node.children) {
          node.children.forEach(child => {
            html += parseRichTextJSON(child);
          });
        }
        break;
        
      case 'paragraph':
        html += '<p>';
        if (node.children) {
          node.children.forEach(child => {
            html += parseRichTextJSON(child);
          });
        }
        html += '</p>';
        break;
        
      case 'heading':
        const level = node.level || 2;
        html += `<h${level}>`;
        if (node.children) {
          node.children.forEach(child => {
            html += parseRichTextJSON(child);
          });
        }
        html += `</h${level}>`;
        break;
        
      case 'list':
        const listTag = node.listType === 'ordered' ? 'ol' : 'ul';
        html += `<${listTag}>`;
        if (node.children) {
          node.children.forEach(item => {
            html += '<li>';
            if (item.children) {
              item.children.forEach(child => {
                html += parseRichTextJSON(child);
              });
            }
            html += '</li>';
          });
        }
        html += `</${listTag}>`;
        break;
        
      case 'text':
        let text = node.value || '';
        if (node.bold) text = `<strong>${text}</strong>`;
        if (node.italic) text = `<em>${text}</em>`;
        html += text;
        break;
        
      case 'link':
        const url = node.url || node.href || '#';
        let linkText = '';
        if (node.children) {
          node.children.forEach(child => {
            linkText += parseRichTextJSON(child);
          });
        }
        html += `<a href="${url}">${linkText}</a>`;
        break;
        
      default:
        if (node.children) {
          node.children.forEach(child => {
            html += parseRichTextJSON(child);
          });
        }
    }
    
    return html;
  };

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initLocationFilter();
      initMultiStepForm();
      renderRichTextJSON();
    });
  } else {
    initLocationFilter();
    initMultiStepForm();
    renderRichTextJSON();
  }
})();
